(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babsee-leestest-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CARD_WIDTH_MM = 53.98;
    const DISTANCE_CM = 40;
    const LEVELS_MM = [17, 14, 12, 11, 8, 6].map(points => points * 25.4 / 72);
    const LEVEL_STRENGTHS = [3, 2.5, 2, 1.5, 1, 0];
    

    const copy = {
      nl: {
        progress: step => `Stap ${step} van 4`,
        footer: 'Een praktische keuzehulp, geen professionele oogmeting. Bij plotselinge veranderingen in je zicht: neem contact op met je huisarts of opticien.',
        introEyebrow: 'Ontdek jouw leescomfort',
        introTitle: 'Hoe makkelijk lees jij kleine letters?',
        introLead: 'Test je leescomfort in een paar eenvoudige stappen. Eerst stellen we je scherm in met een pinpas, zodat de letters op jouw telefoon of computer de juiste grootte hebben. Daarna lees je korte teksten op 35 cm afstand.',
        start: 'Eerst mijn scherm instellen',
        factTime: '± 3 minuten',
        factAccount: 'Geen account nodig',
        factDistance: 'Vaste leesafstand: 35 cm',
        calibrateEyebrow: 'Scherm kalibreren',
        calibrateTitle: 'Eerst even je scherm instellen',
        calibrateLead: 'Schermen geven letters niet allemaal even groot weer. Houd de korte zijde van een pinpas naast de lijn en schuif de regelaar totdat beide even breed zijn. Je hoeft geen pasgegevens in te voeren.',
        cardWidth: 'Werkelijke korte zijde pinpas: 54,0 mm',
        calibrated: 'De breedte klopt · verder',
        readingEyebrow: 'Leestest op 35 cm',
        readingTitle: 'Kun je deze tekst ontspannen lezen?',
        readingHelp: 'Blijf op 35 cm afstand. Kies “Makkelijk leesbaar” als je de hele tekst ontspannen leest. Moet je turen of dichterbij komen? Kies “Moeilijk leesbaar”.',
        level: (current, total) => `Tekst ${current} van ${total}`,
        distance: 'Leesafstand: 35 cm',
        easy: 'Makkelijk leesbaar',
        blurry: 'Moeilijk leesbaar',
        sentences: [
          'Een zonnige ochtend begint vaak met een rustig moment en een helder uitzicht.',
          'Op het terras lees je gemakkelijk de menukaart terwijl je van het buitenlicht geniet.',
          'Een comfortabele leesbril helpt kleine letters rustig en duidelijk in beeld te houden.',
          'Tijdens het lezen horen woorden scherp te blijven zonder dat je met je ogen hoeft te knijpen.',
          'De juiste startsterkte maakt dichtbij lezen prettiger zonder onnodig sterk te corrigeren.',
          'Kleine letters blijven duidelijk wanneer je de tekst op een normale leesafstand bekijkt.'
        ],
        resultEyebrow: 'Jouw advies',
        resultTitle: 'Startsterkte om te proberen',
        resultText: strength => `Voor lezen op 35 cm adviseren we ${strength}. Deze sterkte sluit volgens jouw test het beste aan bij de kleinste tekst die je comfortabel kon lezen.`,
        resultFirstText: strength => `Voor lezen op 35 cm adviseren we ${strength}. Omdat de grootste tekst al wazig werd, is dit de sterkste optie binnen deze test. Leest dit niet comfortabel, laat dan je ogen controleren.`,
        noStrengthTitle: 'Waarschijnlijk nog geen leesbril nodig',
        noStrengthText: 'Je kon ook de kleinste tekst op 35 cm goed lezen. Kies daarom op basis van deze test nog geen plussterkte.',
        summaryDistance: 'Vaste leesafstand',
        summaryCalibration: 'Scherm gekalibreerd',
        yes: 'Ja',
        retry: 'Leestest opnieuw',
        readersTitle: 'Voor je leesmoment',
        readersText: 'Ken je jouw leessterkte al? Kies die bij een Babsee leesbril. Twijfel je, laat je sterkte dan meten.',
        readersButton: 'Bekijk leesbrillen',
        bifocalTitle: 'Voor buiten',
        bifocalText: 'Bekijk zonnebrillen met een leesgedeelte onderin en zonder sterkte bovenin.',
        bifocalButton: 'Bekijk zonnebrillen',
        stale: 'De schermgrootte is gewijzigd. Kalibreer de pinpasbreedte opnieuw voor een betrouwbaar resultaat.'
      },
      de: {
        progress: step => `Schritt ${step} von 4`,
        footer: 'Eine praktische Entscheidungshilfe, keine professionelle Augenmessung. Bei plötzlichen Veränderungen des Sehvermögens: Arzt oder Optiker kontaktieren.',
        introEyebrow: 'Entdecke deinen Lesekomfort',
        introTitle: 'Wie leicht liest du kleine Buchstaben?',
        introLead: 'Teste deinen Lesekomfort in wenigen einfachen Schritten. Zuerst stellen wir deinen Bildschirm mit einer Bankkarte ein, damit die Buchstaben die richtige Größe haben. Danach liest du kurze Texte in 35 cm Abstand.',
        start: 'Zuerst den Bildschirm einstellen',
        factTime: '± 3 Minuten',
        factAccount: 'Kein Konto nötig',
        factDistance: 'Fester Leseabstand: 35 cm',
        calibrateEyebrow: 'Bildschirm kalibrieren',
        calibrateTitle: 'Zuerst den Bildschirm einstellen',
        calibrateLead: 'Bildschirme zeigen Buchstaben unterschiedlich groß an. Halte die kurze Seite einer Bankkarte neben die Linie und verschiebe den Regler, bis beide gleich breit sind. Du musst keine Kartendaten eingeben.',
        cardWidth: 'Tatsächliche kurze Kartenseite: 54,0 mm',
        calibrated: 'Die Breite stimmt · weiter',
        readingEyebrow: 'Lesetest in 35 cm Abstand',
        readingTitle: 'Kannst du diesen Text entspannt lesen?',
        readingHelp: 'Bleibe in 35 cm Abstand. Wähle „Gut lesbar“, wenn du den ganzen Text entspannt liest. Musst du die Augen zusammenkneifen oder näher herangehen? Wähle „Schwer lesbar“.',
        level: (current, total) => `Text ${current} von ${total}`,
        distance: 'Leseabstand: 35 cm',
        easy: 'Gut lesbar',
        blurry: 'Schwer lesbar',
        sentences: [
          'Ein sonniger Morgen beginnt oft mit einem ruhigen Moment und einer klaren Aussicht.',
          'Auf der Terrasse liest du die Speisekarte bequem und genießt dabei das Tageslicht.',
          'Eine komfortable Lesebrille hilft, kleine Buchstaben ruhig und deutlich zu erkennen.',
          'Beim Lesen sollten Wörter scharf bleiben, ohne dass du die Augen zusammenkneifen musst.',
          'Die passende Startstärke macht das Lesen in der Nähe angenehmer, ohne unnötig stark zu korrigieren.',
          'Kleine Buchstaben bleiben deutlich, wenn du den Text in einem normalen Leseabstand betrachtest.'
        ],
        resultEyebrow: 'Deine Empfehlung',
        resultTitle: 'Startstärke zum Ausprobieren',
        resultText: strength => `Für das Lesen in 35 cm Abstand empfehlen wir ${strength}. Diese Stärke passt laut deinem Testergebnis am besten zum kleinsten Text, den du bequem lesen konntest.`,
        resultFirstText: strength => `Für das Lesen in 35 cm Abstand empfehlen wir ${strength}. Da bereits der größte Text unscharf wurde, ist dies die stärkste Option in diesem Test. Wenn das Lesen damit nicht angenehm ist, lass deine Augen überprüfen.`,
        noStrengthTitle: 'Wahrscheinlich noch keine Lesebrille nötig',
        noStrengthText: 'Du konntest auch den kleinsten Text in 35 cm Abstand gut lesen. Wähle deshalb anhand dieses Tests noch keine Plusstärke.',
        summaryDistance: 'Fester Leseabstand',
        summaryCalibration: 'Bildschirm kalibriert',
        yes: 'Ja',
        retry: 'Lesetest wiederholen',
        readersTitle: 'Für deinen Lesemoment',
        readersText: 'Kennst du deine Lesestärke bereits? Wähle sie bei deiner Babsee Lesebrille. Wenn du unsicher bist, lass deine Stärke messen.',
        readersButton: 'Lesebrillen ansehen',
        bifocalTitle: 'Für draußen',
        bifocalText: 'Entdecke Sonnenbrillen mit Leseteil unten und ohne Stärke oben.',
        bifocalButton: 'Sonnenbrillen ansehen',
        stale: 'Die Bildschirmgröße wurde geändert. Kalibriere die Kartenbreite erneut, damit das Ergebnis zuverlässig bleibt.'
      }
    };

    function mount(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const language = (document.documentElement.lang || '').toLowerCase().startsWith('de') ? 'de' : 'nl';
      const text = copy[language];
      const stage = root.querySelector('[data-stage]');
      const progress = root.querySelector('progress');
      const progressText = root.querySelector('[data-progress]');
      const footer = root.querySelector('[data-footer]');
      const backButton = root.querySelector('[data-action="back"]');
      const restartButton = root.querySelector('[data-action="restart"]');

      let state = freshState();
      let screen = 'intro';
      let history = [];

      function freshState() {
        return {
          pixels: 204,
          level: 0,
          calibrated: false,
          viewport: null,
          strength: null,
          difficulty: false
        };
      }

      function escapeHtml(value) {
        return String(value ?? '').replace(/[&<>"']/g, character => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[character]);
      }

      function formatStrength(value) {
        return `+${Number(value).toFixed(2).replace('.', ',')}`;
      }

      function stepFor(name) {
        return { intro: 1, calibrate: 2, prepare: 3, reading: 3, result: 4 }[name] || 1;
      }

      function setNavigation(name) {
        backButton.hidden = history.length === 0;
        restartButton.hidden = name === 'intro';
      }

      function renderIntro() {
        return `
          <section>
            <span class="babsee-test__eyebrow">${escapeHtml(text.introEyebrow)}</span>
            <h1 tabindex="-1">${escapeHtml(text.introTitle)}</h1>
            <p class="babsee-test__lead">${escapeHtml(text.introLead)}</p>
            <div class="babsee-test__actions">
              <button class="babsee-test__button" type="button" data-action="start">${escapeHtml(text.start)}</button>
            </div>
            <div class="babsee-test__facts">
              <span>${escapeHtml(text.factTime)}</span>
              <span>${escapeHtml(text.factAccount)}</span>
              <span>${escapeHtml(text.factDistance)}</span>
            </div>
          </section>
        `;
      }

      function renderCalibration() {
        return `
          <section>
            <span class="babsee-test__eyebrow">${escapeHtml(text.calibrateEyebrow)}</span>
            <h2 tabindex="-1">${escapeHtml(text.calibrateTitle)}</h2>
            <p class="babsee-test__lead">${escapeHtml(text.calibrateLead)}</p>
            <div class="babsee-test__calibration">
              <strong>${escapeHtml(text.cardWidth)}</strong>
              <div class="babsee-test__card-line" data-card-line aria-hidden="true"></div>
              <input type="range" data-scale aria-label="${escapeHtml(text.cardWidth)}">
            </div>
            <div class="babsee-test__actions">
              <button class="babsee-test__button" type="button" data-action="calibrated">${escapeHtml(text.calibrated)}</button>
            </div>
          </section>
        `;
      }

      function renderPrepare() {
        const nl = language === 'nl';
        return `<section>
          <span class="babsee-test__eyebrow">${nl ? 'Klaar voor de leestest' : 'Bereit für den Lesetest'}</span>
          <h2 tabindex="-1">${nl ? 'Zo doe je de test' : 'So funktioniert der Test'}</h2>
          <ol class="babsee-test__instructions">
            <li>${nl ? 'Doe je leesbril af en zorg voor goed licht.' : 'Nimm deine Lesebrille ab und sorge für gutes Licht.'}</li>
            <li>${nl ? 'Meet 35 cm tussen je ogen en het scherm. Houd die afstand tijdens de hele test aan.' : 'Miss 35 cm zwischen deinen Augen und dem Bildschirm. Halte diesen Abstand während des ganzen Tests ein.'}</li>
            <li>${nl ? 'Lees met beide ogen open. De tekst wordt per stap kleiner; stop zodra lezen moeite kost.' : 'Lies mit beiden Augen geöffnet. Der Text wird mit jedem Schritt kleiner; stoppe, sobald das Lesen schwerfällt.'}</li>
          </ol>
          <p class="babsee-test__note">${nl ? 'Draag je een bril of lenzen voor veraf, of zie je met één oog duidelijk slechter? Laat je leessterkte persoonlijk controleren. Deze test bepaalt geen brilrecept.' : 'Trägst du eine Brille oder Kontaktlinsen für die Ferne oder siehst du mit einem Auge deutlich schlechter? Lass deine Lesestärke persönlich prüfen. Dieser Test bestimmt keine Brillenverordnung.'}</p>
          <div class="babsee-test__actions"><button class="babsee-test__button" type="button" data-action="begin-reading">${nl ? 'Ik zit op 35 cm · start de leestest' : 'Ich sitze in 35 cm Abstand · Test starten'}</button></div>
        </section>`;
      }

      function renderReading() {
        const pixelsPerMillimetre = state.pixels / CARD_WIDTH_MM;
        const fontSize = LEVELS_MM[state.level] * pixelsPerMillimetre;
        return `
          <section class="babsee-test__reading">
            <span class="babsee-test__eyebrow">${escapeHtml(text.readingEyebrow)}</span>
            <h2 tabindex="-1">${escapeHtml(text.readingTitle)}</h2>
            <p>${escapeHtml(text.readingHelp)}</p>
            <div class="babsee-test__reading-meta">
              <strong>${escapeHtml(text.level(state.level + 1, LEVELS_MM.length))}</strong>
              <span>${escapeHtml(text.distance)}</span>
            </div>
            <div class="babsee-test__sample" style="font-size:${fontSize.toFixed(2)}px">
              ${escapeHtml(text.sentences[state.level])}
            </div>
            <div class="babsee-test__answers">
              <button class="babsee-test__button" type="button" data-action="easy">${escapeHtml(text.easy)}</button>
              <button class="babsee-test__button babsee-test__button--secondary" type="button" data-action="blurry">${escapeHtml(text.blurry)}</button>
            </div>
          </section>
        `;
      }

      function renderResult() {
        const nl = language === 'nl';
        const readable = state.difficulty ? state.level : LEVELS_MM.length;
        const strength = state.difficulty ? LEVEL_STRENGTHS[state.level] : 0;
        const formattedStrength = (strength > 0 ? '+' : '') + strength.toFixed(1).replace('.', ',');
        const title = strength > 0 ? (nl ? 'Probeeradvies: ' : 'Empfehlung zum Ausprobieren: ') + formattedStrength : (nl ? 'Indicatie: 0,0 — zonder leessterkte' : 'Orientierung: 0,0 — ohne Lesestärke');
        const detail = strength > 0 ? (nl ? 'Volgens de Babsee-testkaart hoort bij de eerste tekst die je niet meer prettig leest een probeeradvies van ' + formattedStrength + '. Probeer deze sterkte op 35 cm afstand en beoordeel of je ontspannen en scherp leest.' : 'Laut Babsee-Testkarte gehört zum ersten Text, den du nicht mehr angenehm liest, eine Empfehlung zum Ausprobieren von ' + formattedStrength + '. Probiere diese Stärke bei 35 cm Abstand und prüfe, ob du entspannt und klar liest.') : (nl ? 'Volgens de Babsee-testkaart is de indicatie 0,0. Dit is geen bevestiging dat je geen leesbril nodig hebt. Ervaar je toch moeite met lezen of andere zichtklachten? Laat je ogen controleren.' : 'Laut Babsee-Testkarte ist die Orientierung 0,0. Das bestätigt nicht, dass du keine Lesebrille brauchst. Hast du Schwierigkeiten beim Lesen oder andere Sehbeschwerden? Lass deine Augen prüfen.');
        return `<section>
          <div class="babsee-test__advice">
            <p class="babsee-test__advice-label">${nl ? 'Jouw indicatieve leesadvies' : 'Deine unverbindliche Leseempfehlung'}</p>
            <h2 tabindex="-1">${title}</h2>
            <p class="babsee-test__lead">${detail}</p>
            <p class="babsee-test__note">${nl ? 'Indicatieve keuzehulp volgens de Babsee-testkaart, aangepast voor dit scherm. Geen oogmeting of brilrecept. Gebruik een recent gemeten sterkte als je die hebt; laat bij twijfel je sterkte controleren.' : 'Unverbindliche Orientierung nach der Babsee-Testkarte, für diesen Bildschirm angepasst. Keine Augenmessung und kein Brillenrezept. Nutze eine aktuell gemessene Stärke, falls vorhanden; lass sie im Zweifel prüfen.'}</p>
          </div>
          <p class="babsee-test__note"><a href="https://cdn.shopify.com/s/files/1/0916/3374/6269/files/Babsee_Leestest.pdf?v=1742565152" target="_blank" rel="noopener">${nl ? "Bekijk de originele Babsee-testkaart (PDF)" : "Original-Babsee-Testkarte ansehen (PDF)"}</a></p>
          <div class="babsee-test__summary">
            <span>${escapeHtml(text.summaryDistance)}</span><strong>35 cm</strong>
            <span>${escapeHtml(text.summaryCalibration)}</span><strong>${escapeHtml(text.yes)}</strong>
            <span>${nl ? 'Gemakkelijk gelezen' : 'Gut gelesene Texte'}</span><strong>${readable} / ${LEVELS_MM.length}</strong>
          </div>
          <div class="babsee-test__collections">
            <article class="babsee-test__collection"><h3>${escapeHtml(text.readersTitle)}</h3><p>${escapeHtml(text.readersText)}</p><a class="babsee-test__button" href="${escapeHtml(root.dataset.readers)}">${escapeHtml(text.readersButton)}</a></article>
            <article class="babsee-test__collection"><h3>${escapeHtml(text.bifocalTitle)}</h3><p>${escapeHtml(text.bifocalText)}</p><a class="babsee-test__button babsee-test__button--secondary" href="${escapeHtml(root.dataset.bifocal)}">${escapeHtml(text.bifocalButton)}</a></article>
          </div>
          <div class="babsee-test__actions"><button class="babsee-test__button babsee-test__button--secondary" type="button" data-action="restart">${escapeHtml(text.retry)}</button></div>
        </section>`;
      }

      function initialiseCalibration() {
        const range = stage.querySelector('[data-scale]');
        const calibration = stage.querySelector('.babsee-test__calibration');
        const maximum = Math.max(96, Math.floor(calibration.clientWidth - 48));
        range.min = '96';
        range.max = String(maximum);
        state.pixels = Math.min(Math.max(state.pixels, 96), maximum);
        range.value = String(state.pixels);
        stage.querySelector('[data-card-line]').style.width = `${state.pixels}px`;
      }

      function render(name, remember = true) {
        if (remember) history.push({ screen, state: structuredClone(state) });
        screen = name;
        const step = stepFor(name);
        progress.value = step;
        progressText.textContent = text.progress(step);
        footer.textContent = text.footer;
        setNavigation(name);

        if (name === 'intro') stage.innerHTML = renderIntro();
        if (name === 'calibrate') stage.innerHTML = renderCalibration();
        if (name === 'prepare') stage.innerHTML = renderPrepare();
        if (name === 'reading') stage.innerHTML = renderReading();
        if (name === 'result') stage.innerHTML = renderResult();

        if (name === 'calibrate') initialiseCalibration();
        stage.querySelector('h1, h2')?.focus({ preventScroll: true });
        if (name !== 'intro') stage.scrollIntoView({ block: 'start', behavior: 'instant' });
      }

      function viewportChanged() {
        if (!state.viewport) return false;
        const current = [window.innerWidth, window.innerHeight, window.visualViewport?.scale || 1];
        return current.some((value, index) => Math.abs(value - state.viewport[index]) > (index === 2 ? 0.01 : index === 1 ? 160 : 2));
      }

      function returnToCalibration() {
        render('calibrate');
        const message = document.createElement('p');
        message.className = 'babsee-test__calibration';
        message.textContent = text.stale;
        stage.prepend(message);
      }

      root.addEventListener('input', event => {
        if (!event.target.matches('[data-scale]')) return;
        state.pixels = Number(event.target.value);
        stage.querySelector('[data-card-line]').style.width = `${state.pixels}px`;
      });

      root.addEventListener('click', event => {
        const button = event.target.closest('[data-action]');
        if (!button || !root.contains(button)) return;
        const action = button.dataset.action;

        if (action === 'start') {
          render('calibrate');
          return;
        }

        if (action === 'calibrated') {
          state.calibrated = true;
          state.level = 0;
          state.strength = null;
          state.difficulty = false;
          state.viewport = [window.innerWidth, window.innerHeight, window.visualViewport?.scale || 1];
          render('prepare');
          return;
        }

        if (action === 'begin-reading') {
          if (viewportChanged()) { returnToCalibration(); return; }
          render('reading');
          return;
        }

        if (action === 'easy') {
          if (viewportChanged()) {
            returnToCalibration();
            return;
          }
          const previousState = structuredClone(state);
          if (state.level < LEVELS_MM.length - 1) {
            state.level += 1;
            history.push({ screen, state: previousState });
            render('reading', false);
          } else {
            state.strength = null;
            history.push({ screen, state: previousState });
            render('result', false);
          }
          return;
        }

        if (action === 'blurry') {
          if (viewportChanged()) {
            returnToCalibration();
            return;
          }
          const previousState = structuredClone(state);
          state.strength = null;
          state.difficulty = true;
          history.push({ screen, state: previousState });
          render('result', false);
          return;
        }

        if (action === 'back') {
          const previous = history.pop();
          if (previous) {
            state = previous.state;
            render(previous.screen, false);
          }
          return;
        }

        if (action === 'restart') {
          state = freshState();
          history = [];
          render('intro', false);
        }
      });

      render('intro', false);
    }

    function initialise(scope = document) {
      if (scope.matches?.('[data-babsee-test]')) mount(scope);
      scope.querySelectorAll?.('[data-babsee-test]').forEach(mount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
